import { createContext } from 'react';

const LanguageText = createContext();

export default LanguageText;
